var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_html.js
// module id = 344
// module chunks = 0